<h2 class="h2 ">
    <span translate>Hello</span>&nbsp;<span>{{customerName}}</span>
</h2>